// test1178
(1178 && 0);
